import React, { forwardRef, HTMLAttributes, useState, useRef } from 'react';
import useEventListener from '@repo-level/core-front/hooks/eventListener';

import { FieldStructure } from '../structures/FieldStructure';
import { useTheme } from 'hooks/theme';

import { ScCheckbox, ScCheckboxBlock, ScCheckboxProps } from './styled';
import { useMedia } from 'modules/common/hooks/useMedia';

export interface CheckboxBlockProps
  extends HTMLAttributes<HTMLInputElement>,
    ScCheckboxProps {
  id: string;
  checked?: boolean;
  disabled?: boolean;
  label?: React.ReactNode;
  error?: React.ReactNode;
  tooltip?: string;
  width?: number;
  height?: number;
}

export const CheckboxBlock = forwardRef<HTMLInputElement, CheckboxBlockProps>(
  ({ label, error, id, withColorBg, tooltip, width, height, ...rest }, ref) => {
    const { images } = useTheme();

    const { isMobile } = useMedia();

    const tooltipRef = useRef<HTMLDivElement>(null);

    const [isVisibleInfo, setIsVisibleInfo] = useState(false);

    useEventListener(
      'mouseenter',
      () => !isMobile && setIsVisibleInfo(true),
      tooltipRef
    );

    useEventListener(
      'mouseleave',
      () => !isMobile && setIsVisibleInfo(false),
      tooltipRef
    );

    useEventListener('click', (event) => {
      const target = event.target;

      if (isMobile && target instanceof Node) {
        if (!tooltipRef.current?.contains(target) || isVisibleInfo) {
          setIsVisibleInfo(false);
        } else {
          setIsVisibleInfo(true);
        }
      }
    });

    return (
      <FieldStructure error={error}>
        <ScCheckboxBlock isVisibleTooltip={!!tooltip && isVisibleInfo}>
          <label htmlFor={id}>
            <ScCheckbox withColorBg={withColorBg} width={width} height={height}>
              <input {...rest} ref={ref} id={id} type="checkbox" />
              <span className="checkbox">
                <span className="border" />
              </span>
            </ScCheckbox>
            {label && <div className="label">{label}</div>}
          </label>
          {tooltip && (
            <div className="tooltip" ref={tooltipRef}>
              <images.smallInfoSymbol.component />
              {isVisibleInfo && (
                <div className="tooltip-content">{tooltip}</div>
              )}
            </div>
          )}
        </ScCheckboxBlock>
      </FieldStructure>
    );
  }
);
